/* ============================================================
   phoneApps.js — SATU daftar app sasaran phone automation
   ============================================================
   Elak senarai kembar (dulu disalin dalam PhoneAutomationView +
   PhoneControlPanelV4 — risiko drift bila tambah app). Semua tempat
   import dari sini.

   Medan:
     id          kunci dalaman + nilai simpanan (`sesaat_phone_app_v1`)
     label       nama papar
     pkg         package Android (untuk launchApp)
     ready       true = boleh guna; false = "Soon" (belum dibina/diuji)
     schedulable true = boleh dijadualkan ikut slot kalendar (cth FB Reels).
                 Shopee = false (telefon perlu bersambung masa post → "Schedule"
                 dikunci untuk Shopee).
     engine      'dump' = skrin app boleh dibaca → robot ikut teks (androidDumpKit),
                 TIADA kalibrasi / Test wajib. Tiada = enjin Shopee (kalibrasi).
     draftOnly   true = simpan Draft sahaja (keputusan user 4 Nov: "buat semua
                 draft dulu, nanti kita tune semula") → Post now + Schedule dikunci.
     contents    jenis post yang disokong ('video' | 'image' | 'text').
     aiLabel     true = app ada suis AI label → pilihan ON/OFF di Control Panel.
     bag         true = app boleh pasang beg kuning (produk TikTok Shop) pada video.
   ⛔ Enjin UNIVERSAL — tambah app baharu = tambah SATU baris di sini sahaja.
   ============================================================ */

export const PHONE_APPS = [
  { id: 'shopee', label: 'Shopee Video', pkg: 'com.shopee.my', ready: true, schedulable: false },
  // FB app phone (4 Nov): reel / post gambar / post text → Draft. Link produk Shopee hanya
  // pada PAGE (pilih nama page di Control Panel). schedulable false: robot phone belum
  // menjadualkan (FB extension kekal untuk jadual).
  {
    id: 'facebook', label: 'Facebook', pkg: 'com.facebook.katana', ready: true, schedulable: false,
    engine: 'dump', draftOnly: true, contents: ['video', 'image', 'text'], aiLabel: true, fbOptions: true,
  },
  // Pakej Asia = com.ss.android.ugc.trill (diukur 4 Nov pada phone MY), BUKAN musically.
  // App phone TikTok TIADA schedule (diukur 4 Nov) → schedulable false.
  {
    id: 'tiktok', label: 'TikTok', pkg: 'com.ss.android.ugc.trill', ready: true, schedulable: false,
    engine: 'dump', draftOnly: true, contents: ['video', 'image', 'text'], aiLabel: true, bag: true,
  },
];

export const PHONE_CONTENT_LABEL = { video: 'Video', image: 'Images', text: 'Text' };

// Pilihan per-browser (dibaca Control Panel + handleRunPhone). try/catch: storan boleh ditutup.
export function bacaPhoneContent(app) {
  const ada = app?.contents || ['video'];
  let v = '';
  try { v = localStorage.getItem('sesaat_phone_content_v1') || ''; } catch { /* storan ditutup */ }
  return ada.includes(v) ? v : ada[0];
}
export function bacaPhoneAiLabel() {
  try { return localStorage.getItem('sesaat_phone_ailabel_v1') !== '0'; } catch { return true; }
}
// FB: nama page untuk post (kosong = profile peribadi) + link produk Shopee pada reel.
export function bacaPhoneFbPage() {
  try { return (localStorage.getItem('sesaat_phone_fbpage_v1') || '').trim(); } catch { return ''; }
}
export function bacaPhoneFbLink() {
  try { return localStorage.getItem('sesaat_phone_fblink_v1') === '1'; } catch { return false; }
}
// TikTok: pasang beg kuning pada video (lalai HIDUP, sama toggle extension "Pasang beg kuning").
export function bacaPhoneTtBag() {
  try { return localStorage.getItem('sesaat_phone_ttbag_v1') !== '0'; } catch { return true; }
}

export const PHONE_APP_IDS = PHONE_APPS.map((a) => a.id);

// Cari app ikut id; fallback app pertama yang READY (bukan "Soon") supaya
// tetapan lama yang tersimpan app belum-sedia tidak menyekat pelanggan.
export function phoneApp(id) {
  return PHONE_APPS.find((a) => a.id === id)
    || PHONE_APPS.find((a) => a.ready)
    || PHONE_APPS[0];
}
